import { TCountryCode } from "@/types/app";
import axios from "axios";

const GET_USEr_GEO_URL =
  "https://api.aftershoot.co/functions/v1/audience/country";

interface CloudAPIResponse<T> {
  status: boolean;
  data: T;
  error: ErrorResponse;
}

interface ErrorResponse {
  message: string;
  code: number;
}

interface GetCountryResponse {
  country: TCountryCode;
}

export const getCountryISO = async () => {
  try {
    const res =
      await axios.get<CloudAPIResponse<GetCountryResponse>>(GET_USEr_GEO_URL);
    const userCountry = res?.data?.data?.country;
    return userCountry ?? "US";
  } catch (error) {
    console.error("Error fetching geo location:", error);
  }
};
